import { HttpClient } from "./http";

class Transactions extends HttpClient {
    constructor() {
        super();
    }

    public async getTransactionCategoryDropdown(params: any) {
        return this.HTTP.get(`/fleet/transaction/category`, { params })
    }

    public async getTransactionCategoryCounts(params: any) {
        return this.HTTP.get(`/fleet/transaction/category-count`, { params })
    }

    public async getVehicalClassCount(params: any) {
        return this.HTTP.get(`/fleet/transaction/vehicle-class-count`, { params })
    }

    public async getVehicalTagBasedCount(params: any) {
        return this.HTTP.get(`/fleet/transaction/tag-id-count`, { params })
    }

    public async getSuspeciousComplaintReasonCode(params: any) {
        return this.HTTP.get(`/fleet/suspicious-transaction/complaint-reason-count`, { params })
    }

    public async getDisputedStatusCount(params: any) {
        return this.HTTP.get(`/fleet/dispute-transaction/status-count`, { params })
    }

    public async getSuspiciousTransaction(data: any) {
        return this.HTTP.post('/fleet/transaction', data)
    }

    public async getTransactionsForVehical(data: any) {
        return this.HTTP.post('/fleet/transaction', data)
    }
    public async getTransactionsForDisputeD(data: any) {
        return this.HTTP.post('/fleet/complaint', data)
    }
    public async getTransactionsForSuspecious(data: any) {
        return this.HTTP.post('/fleet/complaint', data)
    }
    public async getMultipleTransactionList(tranId: any, data: any) {
        return this.HTTP.get(`/fleet/transaction/verified?transaction_id=${tranId}&page=${data.page}&size=${data.size}`)
    }
    public async getCategoryList(id: any) {
        return this.HTTP.get(`/fleet/documents/categories?reason_code_id=${id}`)
    }

    public async uploadBulk(payload: any) {
        return this.HTTP.post(`/fleet/bulk/transactions`, payload)
    }

    public async reasonCodeDropdownList(payload: any) {
        return this.HTTP.get(`/fleet/complaint/reason-code?category=non_technical&type=adjustment&type=transaction`, payload)
    }
    public async getReferenceTransactionData(params: any) {
        return this.HTTP.get(`/fleet/transaction/reference-transaction`, {
            params: {
                page: params.page,
                size: params.size,
                transaction_id: params.transaction_id || '',
                reason_code: params.reason_code || ""
            }
        })
    }
}


export const TransactionsService = new Transactions();
